import Client from "../client/PayMent"
const resource = "/api"

const getListPacekage = (params) => {
  return Client.get(`${resource}/user/packages`, { params })
}

const getCategory = (params) => {
  return Client.get(`${resource}/user/category-telco?platform=6`, { params })
}

const getProducts = (params) => {
  return Client.get(`${resource}/v1/api/v2/user/packages/5/products`, { params })
}

const getProduct = (product_id, params) => {
  return Client.get(`${resource}/user/product/${product_id}`, { params })
}

const getDetailPackage = (packageId, params) => {
  return Client.get(`${resource}/v2/user/packages/${packageId}/products`, { params })
}
const getMySub = () => {
  return Client.get(`${resource}/v2/my_subscription`)
}

const CheckUser = (id, params) => {
  return Client.get(`${resource}/v2/products/${id}/purchase`, { params })
}

const getHistoryTransaction = (params) => {
  return Client.get(`${resource}/v2/history/product`, { params })
}

function getUrlPaygate(data) {
  return Client.post(`${resource}/v1/onlivetv_paygate/client/verify_payment`, data)
}

function getUrlVNPay(data) {
  return Client.post(`${resource}/v1/vnpay/client/create_payment`, data)
}

const checkResultVNPayTransaction = (order_id) => {
  return Client.get(`${resource}/v1/vnpay/client/check_payment?order_id=${order_id}`)
}
const checkResultTransaction = (data) => {
  return Client.post(`${resource}/v1/onlivetv_paygate/callbacks/check_payment`, data)
}

const getSignKeyVOD = (params) => {
  return Client.get(`${resource}/vod/sign_key`, { params })
}

const getSignKeyLive = (params) => {
  return Client.get(`/api/web/sign_key`, { params })
}

const getSignKeyLiveEmbed = (params) => {
  return Client.get(`/api/vod/sign_key_live`, { params })
}

const userRepository = {
  getMySub,
  getListPacekage,
  getDetailPackage,
  CheckUser,
  getHistoryTransaction,
  getCategory,
  getProducts,
  getProduct,
  getUrlPaygate,
  checkResultTransaction,
  getUrlVNPay,
  checkResultVNPayTransaction,
  getSignKeyVOD,
  getSignKeyLive,
  getSignKeyLiveEmbed
}
export default userRepository
